import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import EdgeHealthCharts from './EdgeHealthCharts';
import EdgeQuickStats from './EdgeQuickStats';
import edgeService from '../../../services/edge.service';
import { useTenantStore } from '../../../stores/tenantStore';

interface HealthOverviewProps {
  edgeId: string;
}

const HealthOverview = ({ edgeId }: HealthOverviewProps) => {
  const navigate = useNavigate();
  const selectedTenantId = useTenantStore((s) => s.selectedTenantId);
  const [healthStats, setHealthStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const fetchHealthStats = async () => {
    try {
      setLoading(true);
      const stats = await edgeService.getHealthStats(edgeId);
      setHealthStats(stats);
    } catch (err) {
      console.error('Failed to load health stats:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHealthStats();

    // Refresh health stats every 30 seconds
    const interval = setInterval(fetchHealthStats, 30000);
    return () => clearInterval(interval);
  }, [edgeId, selectedTenantId]);

  return (
    <div className="space-y-6">
      {/* Header with Link to Observability */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Health Overview</h2>
          <p className="text-sm text-gray-500">Real-time status and telemetry for this edge device</p>
        </div>
        <button
          onClick={() => navigate(`/monitoring/observability?edgeId=${edgeId}`)}
          className="btn-secondary inline-flex items-center space-x-2"
        >
          <BarChart3 className="w-4 h-4" />
          <span>Full Observability Dashboard</span>
        </button>
      </div>

      {/* Quick Stats */}
      {loading && !healthStats ? (
        <div className="text-center py-8">Loading health stats...</div>
      ) : (
        <EdgeQuickStats
          fixedClients={healthStats?.fixedClients !== undefined ? `${healthStats.fixedClientsActive || 0} / ${healthStats.fixedClients}` : '0 / 0'}
          mobileDevices={healthStats?.mobileDevices !== undefined ? `${healthStats.mobileDevicesActive || 0} / ${healthStats.mobileDevices}` : '0 / 0'}
        />
      )}

      {/* Charts */}
      <EdgeHealthCharts edgeId={edgeId} />
    </div>
  );
};

export default HealthOverview;

